import React from 'react';

class radarSensor extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_793)">
          <g filter="url(#filter0_d_241_793)">
            <path
              d="M57.9035 4H22.0955C21.0675 4 20.0815 4.404 19.3475 5.126L17.6855 6.764C16.9395 7.5 16.5195 8.504 16.5195 9.55V70.45C16.5195 71.498 16.9395 72.502 17.6855 73.236L19.3475 74.874C20.0795 75.596 21.0655 76 22.0955 76H57.9035C58.9315 76 59.9176 75.596 60.6516 74.874L62.3136 73.236C63.0596 72.5 63.4795 71.496 63.4795 70.45V9.55C63.4795 8.502 63.0596 7.498 62.3136 6.764L60.6516 5.126C59.9196 4.404 58.9335 4 57.9035 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M57.9037 76.7999H22.0957C20.8497 76.7999 19.6737 76.318 18.7877 75.444L17.1257 73.806C16.2337 72.9259 15.7217 71.702 15.7217 70.45V9.54995C15.7217 8.29595 16.2337 7.07395 17.1257 6.19395L18.7877 4.55595C19.6757 3.68195 20.8497 3.19995 22.0957 3.19995H57.9037C59.1497 3.19995 60.3257 3.68195 61.2117 4.55595L62.8737 6.19395C63.7657 7.07395 64.2777 8.29795 64.2777 9.54995V70.45C64.2777 71.7039 63.7657 72.9259 62.8737 73.806L61.2117 75.444C60.3237 76.318 59.1497 76.7999 57.9037 76.7999ZM22.0957 4.79995C21.2717 4.79995 20.4957 5.11795 19.9097 5.69595L18.2477 7.33395C17.6577 7.91595 17.3197 8.72395 17.3197 9.54995V70.45C17.3197 71.278 17.6577 72.086 18.2477 72.6659L19.9097 74.3039C20.4957 74.882 21.2717 75.2 22.0957 75.2H57.9037C58.7277 75.2 59.5037 74.882 60.0897 74.3039L61.7517 72.6659C62.3417 72.0839 62.6797 71.276 62.6797 70.45V9.54995C62.6797 8.72195 62.3417 7.91395 61.7517 7.33395L60.0897 5.69595C59.5037 5.11795 58.7277 4.79995 57.9037 4.79995H22.0957Z"
              fill="#84827E"
            />
            <path
              d="M30.6077 27.48H24.3477V31.394H30.6077V27.48Z"
              fill="url(#paint0_linear_241_793)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_793"
            x="14.3217"
            y="1.79995"
            width="54.5557"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_793"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_793"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_793"
            x1="25.2281"
            y1="27.8301"
            x2="27.4821"
            y2="31.9652"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_793">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}
export default radarSensor;
